import { render } from "./MyCampaignsView.vue?vue&type=template&id=896e81f0"
import script from "./MyCampaignsView.vue?vue&type=script&lang=js"
export * from "./MyCampaignsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__